/* eslint-disable func-style */
import { checkIfNumber } from 'src/tpbp-core/utils/common.utils'
import { RULE_REGEXP } from './field-set.const'
import type { InputValidationRule } from './inputs.types'

export const requiredValidator: InputValidationRule = (value: unknown) => {
  const message = 'common.errors.missing-required-field'

  if (Array.isArray(value)) return value.length > 0 || message

  if (typeof value === 'number') return checkIfNumber(value) || message

  if (typeof value === 'string') return value.length > 0 || message

  return !!value || message
}

export const emailValidator: InputValidationRule = (value: string) => {
  if (!value) return true

  return RULE_REGEXP.EMAIL.test(value) || 'common.errors.invalid-email'
}

export const phoneNumberValidator: InputValidationRule = (value: string) => {
  if (!value) return true

  return RULE_REGEXP.PHONE_NUMBER.test(value) || 'common.errors.invalid-phone'
}

export const integerValidator: InputValidationRule = (value: string) => {
  if (!value) return true

  return RULE_REGEXP.INTEGER.test(value) || 'common.errors.invalid-integer'
}

export const numberValidator: InputValidationRule = (value: string) => {
  if (!value) return true

  return RULE_REGEXP.NUMBER.test(value) || 'common.errors.invalid-number'
}
